export { default as TabsMenu } from './tabs-menu';
